import cx from "classnames";
import { ReactNode } from "react";

import Box from "../Box";
import { SplitControlContext, SplitControlContextProps } from "./context";
import styles from "./styles.module.css";

type SplitControlWrapperProps = {
  children: ReactNode;
} & SplitControlContextProps;

const SplitControlWrapper = ({ children, ...restProps }: SplitControlWrapperProps) => {
  return (
    <SplitControlContext.Provider value={restProps}>
      <Box className={cx(styles.splitControlWrapper, styles[restProps.variant])}>{children}</Box>
    </SplitControlContext.Provider>
  );
};

SplitControlWrapper.displayName = "DS.SplitControl.Wrapper";

export default SplitControlWrapper;
